import styled from 'styled-components';

interface ICardModuleProps {
  background: string;
  checked?: boolean;
  bgColor?: string;
}

export const Container = styled.div<ICardModuleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  border-radius: ${props => props.theme.radius.primary};
  width: 100%;
  height: 100%;
  color: #ffffff;
  background: url(${props => props.background}) !important;
  background-color: ${props => props.bgColor} !important;
  background-size: cover !important;
  background-repeat: no-repeat;
  overflow: hidden;
  transition: all .25s ease-in-out;
  min-height: 320px;
  text-decoration: none;
  border: 1px solid ${props => props.theme.cards.border};

  &.checked {
    animation: pulseAnimationCss 1s infinite;
  }

  @media (max-width: 620px) {
    background-image: none !important;
  }

  &:hover {
    cursor: pointer;

    a svg {
      margin-left: 0.25rem;
    }
  }


  > header {

    > div {
      margin-bottom: 1rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1rem;

      > h2 {
        color: #ffffff;
        font-size: 2rem;

        /* TABLET MINI */
        @media (max-width: 950px) {
          font-size: 1.75rem;
        }
      }

      > aside {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        width: 32px;
        border-radius: 50%;
        transition: all .2s ease-in-out;
        background: ${props => props.theme.cards.primary};
        
        input[type="radio"] {
          border: 3px solid #ffffff52;
          background-color: transparent;
          border: .0625em solid rgba(255,255,255,.5);
          border-radius: 50%;
          box-shadow: inset 0 0 0 0 white;
          cursor: pointer;
          font: inherit;
          height: 100%;
          outline: none;
          width: 100%;
          -moz-appearance: none;
          -webkit-appearance: none;
      
        }


        > div {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        > svg {
          padding-top: 2px;
          color: ${props => props.theme.colors.white};
        }
      }
    }
  
    > p { 
      color: #ffffff;
      font-size: 14px;
      line-height: 1.5;
      text-align: justify;
      width: 80%;

      @media (max-width: 620px) {
        width: 100%;
        margin-bottom: 1rem;
      }
    }
  }

  > footer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      display: inline-flex;
      gap: 1rem;
      
      > span {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 24px;
        font-weight: 600;

        @media (max-width: 620px) {
          font-size: 1rem;
        }
      }
    }
  }
`;
